module.exports = __webpack_public_path__ + "static/img/award3_a.01c03dc.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/mobile_img/index/award3_a.png
// module id = nUS/
// module chunks = 7